import "./App.css";
import Countries from "./components/Countries/Countries";

function App() {
  return (
    <div>
      <Countries />
    </div>
  );
}

export default App;
